import React from 'react';

import { ButtonGroup, IconButton, LinkButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { ConfirmationDialog } from '@eika/confirmation-dialog';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../../../hooks/useTranslation';

type Props = {
    id: string;
    title: string;
    children: React.ReactNode;
    isLoading: boolean;
    removeNotification: () => Promise<void>;
    areYouSureState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

const AccountTransactionActiveToggleContent: React.FC<Props> = ({
    id,
    title,
    children,
    isLoading,
    removeNotification,
    areYouSureState: [showAreYouSure, setShowAreYouSure],
}) => {
    const { cancel, pushNotifications: pushNotificationText } = useTranslation();
    if (showAreYouSure) {
        return (
            <div className="account-transaction-notification-settings__active-toggle-confirmation-dialog">
                <ConfirmationDialog
                    title={pushNotificationText.deleteFlow.areYouSure}
                    id={id}
                    footer={
                        <ButtonGroup
                            className="account-transaction-notification-settings__active-toggle-confirmation-dialog-submit-wrapper"
                            primaryAction={
                                <ButtonWithSpinner showSpinner={isLoading} onClick={() => removeNotification()}>
                                    {pushNotificationText.deleteFlow.deleteNotification}
                                </ButtonWithSpinner>
                            }
                            secondaryAction={<LinkButton onClick={() => setShowAreYouSure(false)}>{cancel}</LinkButton>}
                        />
                    }
                    show={showAreYouSure}
                    onExitFocus={() => setShowAreYouSure(false)}
                />
            </div>
        );
    }
    return (
        <>
            <span className="account-transaction-notification-settings__active-toggle-button-content">
                <span className="bold">{title}</span>
                <span>{children}</span>
            </span>
            <IconButton
                icon={IconTypes.SLETT_24}
                screenReaderText={pushNotificationText.deleteFlow.deleteNotification}
                onClick={() => setShowAreYouSure((prev) => !prev)}
            />
        </>
    );
};

export default AccountTransactionActiveToggleContent;
